
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Singleroompginpune() {



    const cardData =
    {
        keyword: 'Single Room PG in Pune',
        heading: 'Shree Swami Samarth PG :  Single Room PG in Pune',
        headingDescription: 'Shree Swami Samarth PG offers well-maintained single room PG in Pune, ideal for students and professionals who prefer privacy and a peaceful living environment. Our single occupancy rooms are fully furnished with comfortable beds, study tables, wardrobes, and attached facilities to ensure maximum convenience. Residents enjoy amenities such as high-speed WiFi, 24x7 water supply, hygienic meals, and CCTV security, making it a safe and hassle-free choice for individuals. Located in prime areas of Pune near IT parks, colleges, and corporate hubs, our PG ensures easy connectivity and smooth daily commutes. With regular housekeeping, disciplined management, and affordable rent plans, Shree Swami Samarth PG provides the perfect balance of comfort, safety, and independence for those seeking single room accommodation in Pune.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Private Fully Furnished Rooms",
    "description": "Each single room is thoughtfully designed with a comfortable bed, study table, chair, wardrobe, and ample storage space. Residents enjoy complete privacy with a homely environment, perfect for focused study and peaceful living."
  },
  {
    "title": "Attached Bathroom Facility",
    "description": "Every single room comes with a well-maintained attached bathroom for convenience and hygiene. Residents benefit from hot water supply and modern fittings for a comfortable daily routine."
  },
  {
    "title": "Nutritious Home-Style Meals",
    "description": "Freshly prepared breakfast, lunch, and dinner are provided daily. The menu is designed to be balanced, hygienic, and tasty, ensuring residents maintain a healthy lifestyle even while living away from home."
  },
  {
    "title": "High-Speed Wi-Fi Access",
    "description": "Uninterrupted internet connectivity is available in each room. Students can attend online classes and professionals can work from home without any disturbance, making it an ideal choice for digital convenience."
  },
  {
    "title": "24/7 Security & Safety",
    "description": "Round-the-clock CCTV surveillance and secure entry points ensure a safe environment for residents. Strict visitor policies and responsible staff add an extra layer of safety for single-room occupants."
  },
  {
    "title": "Regular Housekeeping",
    "description": "Daily cleaning and housekeeping services keep the rooms and premises tidy. Residents don’t have to worry about maintenance, as hygiene is given top priority by the management."
  },
  {
    "title": "Prime Location in Pune",
    "description": "Situated in a well-connected area, the PG provides easy access to major colleges, IT parks, shopping centers, and public transport. This makes commuting and daily living convenient and stress-free."
  },
  {
    "title": "Affordable & Transparent Rent",
    "description": "Single room accommodation is available at budget-friendly prices with no hidden charges. Flexible rental plans make it suitable for both students and working professionals seeking independent living."
  }
],



"services": [
  {
    "name": "Single Room PG in Pune",
    "description": "Shree Swami Samarth PG offers premium single room PGs in Pune for individuals seeking personal space, privacy, and a quiet environment. Each room is well-ventilated and fully equipped with modern amenities including attached bathrooms, Wi-Fi, and 24/7 water supply. Ideal for both students and professionals."
  },
  {
    "name": "1 BHK PG in Pune",
    "description": "Looking for a more spacious living option? Shree Swami Samarth PG provides 1 BHK PG accommodations in Pune, perfect for individuals or couples preferring an independent lifestyle with a separate living area, bedroom, and kitchenette—all in a clean, secure environment."
  },
  {
    "name": "Private Room PG Pune",
    "description": "Enjoy complete privacy with Shree Swami Samarth’s private room PGs in Pune. These rooms are designed for single occupants who value solitude and comfort, with facilities like personal wardrobes, workspaces, and air conditioning available in select units."
  },
  {
    "name": "Independent PG in Pune",
    "description": "Shree Swami Samarth PG offers independent PG living spaces in Pune that combine the freedom of living alone with the security and convenience of managed accommodation. Ideal for working professionals and remote workers who prefer self-sufficiency and tranquility."
  },
  {
    "name": "Non-sharing PG in Pune",
    "description": "Say goodbye to shared spaces. Shree Swami Samarth PG provides non-sharing PG options in Pune where you enjoy exclusive access to your room, washroom, and amenities—ensuring privacy, hygiene, and a peaceful lifestyle."
  },
  {
    "name": "Single Occupancy PG Pune",
    "description": "Designed for individuals who prefer living alone, Shree Swami Samarth PG’s single occupancy rooms in Pune offer a comfortable and distraction-free environment. Each room is furnished and maintained with daily housekeeping, ensuring a worry-free stay."
  },
  {
    "name": "Affordable Single Room PG in Pune",
    "description": "Get premium comfort at a budget price with Shree Swami Samarth’s affordable single room PGs in Pune. Our pricing is ideal for students and early-career professionals who need value without compromising on quality or safety."
  },
  {
    "name": "Luxury Single PG in Pune",
    "description": "For those who expect more, Shree Swami Samarth PG presents luxury single PG rooms in Pune. These upscale rooms feature stylish interiors, AC, high-speed internet, daily housekeeping, and premium meals—delivering a hotel-like experience for long stays."
  },
  {
    "name": "Furnished Single PG in Pune",
    "description": "Move in without hassle. Shree Swami Samarth PG offers fully furnished single rooms in Pune with essentials like beds, mattresses, wardrobes, study desks, and curtains—ready to live from day one."
  },
  {
    "name": "Monthly PG for Singles in Pune",
    "description": "Shree Swami Samarth PG provides monthly rental options for singles in Pune, with flexible stay terms, no lock-in periods, and transparent billing—perfect for interns, temporary project staff, or students in transition."
  },
  {
    "name": "Single Room Hostel Pune",
    "description": "Need a hostel setup but with personal space? Shree Swami Samarth PG’s single room hostel options in Pune combine the affordability of a hostel with the privacy of individual living. Ideal for exam prep, freelancers, and serious students."
  }
],
"tableData": [
  ["Single Room PG in Pune", "1 BHK PG in Pune"],
  ["Private Room PG Pune", "Independent PG in Pune"],
  ["Non-sharing PG in Pune", "Single Occupancy PG Pune"],
  ["Affordable Single Room PG in Pune", "Luxury Single PG in Pune"],
  ["Furnished Single PG in Pune", "Monthly PG for Singles in Pune"],
  ["Single Room Hostel Pune", ""]
],





"whychoose": [
    {
        "WhyChooseheading": "Spacious and Private Single Room PG in Pune",
        "WhyChoosedescription": "At Shree Swami Samarth PG, we offer thoughtfully designed single occupancy rooms ideal for individuals seeking privacy and peace. Each room is fully furnished with a comfortable bed, study table, wardrobe, and high-speed Wi-Fi—creating a personal space where you can relax, work, and live independently without compromise."
    },
    {
        "WhyChooseheading": "Prime PG Locations Across Pune’s Key Areas",
        "WhyChoosedescription": "Our PGs are located in top residential and commercial hubs like Hinjewadi, Kharadi, Viman Nagar them perfect for students and professionals. Whether you're working in an IT park or studying in a reputed institution, our well-connected locations make your daily commute fast and convenient."
    },
    {
        "WhyChooseheading": "Modern Amenities for a Comfortable Lifestyle",
        "WhyChoosedescription": "Each single room comes with access to modern amenities such as daily housekeeping, laundry facilities, 24x7 hot water, RO drinking water, power backup, and fast Wi-Fi. Our rooms are designed for both functionality and comfort, ensuring that your stay feels more like home than a typical PG."
    },
    {
        "WhyChooseheading": "High Standards of Safety and Hygiene",
        "WhyChoosedescription": "Your well-being is our top priority. Shree Swami Samarth PG maintains strict hygiene protocols with regular room cleaning, sanitized common areas, and pest control. The premises are secured with CCTV surveillance, biometric entry, and dedicated wardens, ensuring you feel safe around the clock."
    },
    {
        "WhyChooseheading": "Healthy and Homely Food Options",
        "WhyChoosedescription": "Enjoy nutritious, home-style meals freshly prepared every day in our hygienic kitchens. We offer vegetarian and non-vegetarian options with customizable meal plans. The food is not only tasty and filling but also keeps you energized throughout your work or study hours."
    },
    {
        "WhyChooseheading": "Flexible Rental Options for Every Budget",
        "WhyChoosedescription": "Our single room PG in Pune is available with multiple rental plans—monthly, quarterly, or annual—to suit your stay duration and budget. Pricing is transparent, with no hidden costs, and includes water, electricity, and maintenance services for complete peace of mind."
    },
    {
        "WhyChooseheading": "Separate PGs for Boys and Girls",
        "WhyChoosedescription": "We offer dedicated PG accommodations for males and females to ensure privacy and comfort. Both hostels are managed with care and feature gender-specific facilities, so residents can enjoy a secure and respectful living experience."
    },
    {
        "WhyChooseheading": "24/7 Support and Maintenance Assistance",
        "WhyChoosedescription": "From minor repairs to urgent needs, our support staff is available at all times. Residents can easily raise service requests through phone or app-based systems, and our on-site team ensures issues are resolved quickly—making your stay stress-free and convenient."
    }
]


















    }

const faqData = [
    {
        question: "How can I book a single room PG in Pune at Shree Swami Samarth PG?",
        answer: "You can book a single room at Shree Swami Samarth PG by contacting us via phone or visiting our property in Pune. Online booking support is also available."
    },
    {
        question: "Are single rooms available for both boys and girls at your PG in Pune?",
        answer: "Yes, Shree Swami Samarth PG offers separate single room accommodations for both boys and girls in Pune, ensuring privacy and comfort."
    },
    {
        question: "What facilities are included in the single room PG at Shree Swami Samarth PG in Pune?",
        answer: "Our single room PGs in Pune include amenities like Wi-Fi, bed, cupboard, study table, attached bathroom, meals, and 24/7 CCTV security."
    },
    {
        question: "Is food included in the rent for single room PG at your Pune location?",
        answer: "Yes, we offer home-cooked meals as part of the rent for all single room PG residents at Shree Swami Samarth PG in Pune."
    },
    {
        question: "What is the rent for a single room PG in Pune at Shree Swami Samarth PG?",
        answer: "Rent for single room PGs depends on room type and amenities. Please contact us directly for current pricing and availability."
    },
    {
        question: "Is there a deposit required for booking a single room PG at your Pune property?",
        answer: "Yes, a refundable security deposit is required at the time of booking. The amount varies by room type."
    },
    {
        question: "Is the PG safe for solo living in Pune?",
        answer: "Absolutely. Our PG has round-the-clock security, CCTV surveillance, and a warden on-site to ensure a safe and secure environment."
    },
    {
        question: "Do you allow short-term stays in single room PGs at Shree Swami Samarth PG?",
        answer: "Short-term stays may be allowed depending on availability. Please contact us for custom stay durations and pricing."
    },
    {
        question: "Can working professionals book single room PGs at your Pune facility?",
        answer: "Yes, we welcome both students and working professionals at our single room PG accommodations in Pune."
    },
    {
        question: "How do I contact Shree Swami Samarth PG for booking or inquiries?",
        answer: "You can call us directly at +91 9594917913 for bookings, availability, or to schedule a visit to our PG in Pune."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Akash Mehta',
        designation: 'Software Engineer, Magarpatta Tech Park, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“The single room at Shree Swami Samarth PG is perfect for working professionals. Clean, private, and peaceful—just what I needed after long workdays.”',
    },
    {
        name: 'Ms. Pooja Kulkarni',
        designation: 'CA Aspirant, Deccan Area, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“Finding a single room PG in Pune that feels like home is rare. The staff here is supportive, food is great, and the security is very reassuring.”',
    },
];















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Single Room PG in Pune",
  "image": "https://swamisamarthpg.com/assets/images/single-room-pg.jpg", // Replace with actual image URL
  "description": "Premium single room PG accommodation in Pune offering privacy, comfort, and affordability. Ideal for singles seeking furnished, non-sharing rooms with monthly rental options in prime locations.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000",         // Replace with actual price if available
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/single-room-pg"  // Replace with actual page URL if different
  }
};





    return (
        <div>
<Helmet>
  <title>Single Room PG in Pune | Private & Furnished 1 BHK PG</title>
  <meta 
    name="description" 
    content="Find the best single room PG in Pune with Shree Swami Samarth PG. Enjoy private, furnished, and affordable non-sharing rooms. Perfect for singles looking for comfort and convenience in Pune." 
  />
  <meta 
    name="keywords" 
    content="Single Room PG in Pune, 1 BHK PG in Pune, Private Room PG Pune, Independent PG in Pune, Non-sharing PG in Pune, Single Occupancy PG Pune, Affordable Single Room PG in Pune, Luxury Single PG in Pune, Furnished Single PG in Pune, Monthly PG for Singles in Pune, Single Room Hostel Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Singleroompginpune;